import React, { useEffect } from "react";
import { trackHowToPlayViewed } from '../../utils/activityTracker';
import useAchievements from '../../hooks/useAchievements';
import { useAuth } from '../../contexts/AuthContext';
import "./PokemonHowToPlay.scss";

const HowToPlayContent = () => (
  <>
    <h2 className="pokemon-how-to-play__title">How to Play Pokemon</h2>
    <ul className="pokemon-how-to-play__list">
      <li className="pokemon-how-to-play__list-item">
        Try to guess the name of a <b>Pokemon</b> from the original 151 chosen at random!
      </li>
      <li className="pokemon-how-to-play__list-item">
        Each guess will be checked for matching <b>Type 1</b>, <b>Type 2</b>, <b>Color</b>, <b>Evolution Stage</b>, <b>Evolution Method</b>, <b>Height</b>, and <b>Weight</b>.
      </li>
      <li className="pokemon-how-to-play__list-item">
        <span className="pokemon-how-to-play__highlight-color pokemon-how-to-play__highlight-color--blue">Blue</span> means your guess matches the secret Pokemon in that category.<br />
        <span className="pokemon-how-to-play__highlight-color pokemon-how-to-play__highlight-color--yellow">Yellow</span> (for height/weight) means your guess is close to the target with directional arrows.<br />
        <span className="pokemon-how-to-play__highlight-color pokemon-how-to-play__highlight-color--pink">Pink</span> means no match.
      </li>
      <li className="pokemon-how-to-play__list-item">
        After <b>3 incorrect guesses</b>, you can unlock a hint that shows the Pokemon's description!
      </li>
      <li className="pokemon-how-to-play__list-item">
        Use the <b>Pokemon Directory</b> to browse Pokemon and filter by type, evolution stage, and more.
      </li>
      <li className="pokemon-how-to-play__list-item">
        Guess until you find the right Pokemon.
      </li>
    </ul>
    <div className="pokemon-how-to-play__tip">
      <b>Tip:</b> Look for directional arrows (↑↓) on height and weight to guide your next guess!
    </div>
  </>
);

const PokemonHowToPlay = ({ show, onClose, gameId }) => {
  const { handleNewAchievements } = useAchievements();
  const { isAuthenticated } = useAuth();
  
  // Track when the modal is shown (only for authenticated users)
  useEffect(() => {
    if (show && gameId && isAuthenticated) {
      const trackGuideView = async () => {
        const response = await trackHowToPlayViewed(gameId);
        if (response && response.newAchievements && response.newAchievements.length > 0) {
          handleNewAchievements(response.newAchievements);
        }
      };
      trackGuideView();
    }
  }, [show, gameId, isAuthenticated, handleNewAchievements]);

  if (!show) return null;

  return (
    <div className="pokemon-how-to-play" onClick={onClose}>
      <div className="pokemon-how-to-play__panel" onClick={e => e.stopPropagation()}>
        <button className="pokemon-how-to-play__close-button" onClick={onClose}>
          ✕
        </button>
        <HowToPlayContent />
      </div>
    </div>
  );
};

export default PokemonHowToPlay;